import ReactAudioPlayer from "react-audio-player";
import { checkIfHasBadWordsAndSocialMedia } from "../../helpers/et3-text-checker/social-media-and-bad-words";
import Et3Image from "../../core/et3-Image";
import { withLiteObserverAndTheme } from "../../core/et3-enhanced-render";
import Et3Text from "../../core/et3-text";
import i18n, { Ti18nKeys } from "../../constants/i18n";
import {
  isDefinedArray,
  isDefinedString,
  isNumber,
  isPositiveNumber,
  isString,
  reduce
} from "et3-type-guards";
import getCorePopUpStore from "../../stores/core/core-popup-store";
import getUserEditProfileStore from "../../stores/user-store/edit-profile-store";
import Et3Button from "../../core/et3-button";
import {
  getWorkById,
  getEducationById,
  getMartialStatusByKeyForMale,
  getMartialStatusByKeyForFemale,
  getCountryByKey,
  et3ReadableDecimalNumber
} from "../../helpers/et3-data-helper";
import configuration from "../../configuration/keys/index";
import { colors } from "../../core/et3-theme/colors";
import { CSSProperties } from "react";
import { Link } from "react-router-dom";
import getCoreHistoryStore from "../../stores/core/core-history-store";
import getMyCSRPerformanceStore from "../../stores/csr-store/csr-performance";
import { getClientReadableText } from "../../helpers/et3-get-client-readable-text";
import getDevelopmentAlarmsStore from "../../stores/developer-store/development_alarms-store";
import ET3Div from "../../core/et3-div";
import getQAStore from "../../stores/qa";
import getPermissionStore from "../../stores/supervisor-store/permission-store";
import {
  FEATURE_ROLLOUT_PICKER_OPTIONS,
  KHATTABAT_CAPACITY_PICKER_OPTIONS,
  SUPERVISOR_PERMISSIONS_OPTIONS
} from "../../constants/picker-entries-constants";
import getAuditStore from "../../stores/auditor-store/audit-store";
import getTBWStore from "../../stores/developer-store/tbw-store";
import getSuperviseStore from "../../stores/supervisor-store/supervise-store";
import {
  E_ADMIN_ROLE,
  E_MESSAGE_DELETION_STATUS,
  StringOrNumber,
  TCorePage,
  TOnCallTeams,
  TReceiptCompensationTitles,
  TTBWExtraData
} from "../../Types";
import Et3Margin from "../../core/et3-ui/ET3Margin";
import getFlaggedDesctiprionStore from "../../stores/supervisor-store/flagged-description-store";
import Et3TextInput from "../et3-input/et3-text-input";
import getSupervisorReceiptStore from "../../stores/supervisor-store/supervisor-receipt-compensation-store";
import React from "react";
import Et3ATag from "../../core/et3-a-tag";
import getCorePersonalStore from "../../stores/core/core-personal-store";
import getInvestigationCasesStore from "../../stores/investigation-cases-store";
import getUserMessageIdStore from "../../stores/user-store/message-id-store";
import getOnCallTeamStore from "../../stores/developer-store/on-call-team-store";
import getResetPasswordStore from "../../stores/supervisor-store/reset-password-store";
import getUserMessagesStore from "../../stores/user-store/messages-store";
import Et3Picker from "../et3-input/et3-picker";
import { TEt3PickerSingleValue } from "../../TypesNEW";
import {
  DESCRIPTION_EVENTS,
  PICTURE_EVENTS
} from "../../constants/admin-events-constants";
import getSupervisorKhattabatStore from "../../stores/supervisor-store/supervisor-khattabat-store";
import { getExtraDataParts } from "../../helpers/et3-get-event-list";
import getUserAdvancedStore from "../../stores/user-store/advanced-store";
import getWebPayments from "../../stores/auditor-store/web-payments";
import { EHyperpayPaymentStatus } from "../../constants/enum/hyperpay-payment-status";

export const ClientReadableText = withLiteObserverAndTheme<{ text: string }>(
  (props) => {
    const { text } = props;
    return (
      <Et3Text
        fontFamily={"LIGHT"}
        fontSize={15}
        text={getClientReadableText(`${text}`)}
        isSpan={true}
        color={colors.all.maastrichtBlue}
        style={{
          width: "100%",
          textAlign: "center",
          wordWrap: "break-word"
        }}
      />
    );
  }
);

export const ClientReadablePercentage = withLiteObserverAndTheme<{
  value: string;
}>((props) => {
  const { value } = props;
  const numericalValue = parseFloat(value.replace("%", ""));
  const roundedValue = `${et3ReadableDecimalNumber(numericalValue, 2)}`;
  let stringValue = roundedValue;
  if (!stringValue.includes(".")) {
    stringValue = stringValue + ".00";
  }
  const text = `${stringValue}%`;
  return (
    <Et3Text
      fontFamily={"LIGHT"}
      fontSize={15}
      text={text}
      isSpan={false}
      color={colors.all.black}
      style={{ textAlign: "center" }}
    />
  );
});

export const EditProfileData = withLiteObserverAndTheme<{
  editedValue: string;
  editProfileKey: string;
}>((props) => {
  const { editedValue, editProfileKey, theme } = props;
  const { colors } = theme;

  let data;
  if (editProfileKey === "WORK") {
    const value = reduce(() => editedValue, "");
    data = getWorkById(parseInt(`${value}`, 10));
  } else if (editProfileKey === "EDUCATION") {
    const value = reduce(() => editedValue, "");
    data = getEducationById(parseInt(`${value}`, 10));
  } else if (editProfileKey === "MARITAL_STATUS") {
    const value = reduce(() => editedValue, "");
    const gender = getUserEditProfileStore().userToEditCurrentGender.get();
    if (gender === "m") {
      data = getMartialStatusByKeyForMale(`${value}`);
    } else {
      data = getMartialStatusByKeyForFemale(`${value}`);
    }
  } else if (editProfileKey === "NATIONALITY") {
    const value = reduce(() => editedValue, "");
    data = getCountryByKey(`${value}`);
  } else {
    data = reduce(() => editedValue, "");
  }

  return (
    <Et3Text
      fontFamily={"MEDIUM"}
      fontSize={20}
      text={`${data}`}
      isSpan={false}
      color={colors.all.maastrichtBlue}
      style={{}}
    />
  );
});

export const EditProfileDataAction = withLiteObserverAndTheme<{
  actionKey: string;
}>((props) => {
  const { actionKey } = props;
  const isUserStatusDeleted =
    getUserEditProfileStore().userStatus.get() === "deleted";

  return (
    <Et3Button
      isEnabled={!isUserStatusDeleted}
      onClick={() => {
        if (actionKey === "NATIONALITY") {
          getCorePopUpStore().openEditCountryPopUp();
        }
        if (actionKey === "AGE") {
          getCorePopUpStore().openEditAgePopUp();
        }
        if (actionKey === "WEIGHT") {
          getCorePopUpStore().openEditWeightPopUp();
        }
        if (actionKey === "HEIGHT") {
          getCorePopUpStore().openEditHeightPopUp();
        }
        if (actionKey === "MARITAL_STATUS") {
          getCorePopUpStore().openEditMaritalStatusPopUp();
        }
        if (actionKey === "WORK") {
          getCorePopUpStore().openEditWorkPopUp();
        }
        if (actionKey === "EDUCATION") {
          getCorePopUpStore().openEditEducationPopUp();
        }
      }}
      size="SMALL"
      type="APPROVE"
      text="EDIT"
    />
  );
});

export const MessageType = withLiteObserverAndTheme<{
  message: string;
  messageType: string;
}>((props) => {
  const { theme, message, messageType } = props;
  const { colors, unitY, unitX } = theme;
  const { hasBadWords, hasSocialMedia } =
    checkIfHasBadWordsAndSocialMedia(message);
  const textColors = hasBadWords
    ? {
        backgroundColor: colors.all.red,
        textColor: colors.all.white
      }
    : hasSocialMedia
      ? {
          backgroundColor: colors.all.orange,
          textColor: colors.all.white
        }
      : {
          backgroundColor: colors.all.transparent,
          textColor: colors.all.black
        };

  if (messageType === "khotabe_message") {
    const parsedMessage = JSON.parse(`${message}`);
    const messageType = reduce(() => parsedMessage.subType, "");
    const messageText =
      messageType === "LIKE_PROFILE_MESSAGE"
        ? reduce(() => parsedMessage.text, "")
        : message;

    return (
      <Et3Text
        fontFamily={"MEDIUM"}
        fontSize={20}
        text={messageText}
        isSpan={false}
        color={colors.all.black}
        style={{
          width: "100%",
          justifyContent: "center",
          alignItems: "center",
          wordWrap: "break-word",
          overflow: "hidden",
          backgroundColor: textColors.backgroundColor
        }}
      />
    );
  }

  if (messageType === "picture")
    return (
      <Et3Image
        type={"ONLINE"}
        alt={i18n.get("ALKHATTABA_ADMIN")}
        imageName={`${message}`}
        size={140}
        onClick={() => {}}
        style={{}}
      />
    );

  if (messageType === "voice")
    return (
      <ReactAudioPlayer
        src={`${message}`}
        autoPlay={false}
        controls
        style={{ height: 60 * unitY, width: 500 * unitX }}
      />
    );

  return (
    <Et3Text
      fontFamily={"MEDIUM"}
      fontSize={20}
      text={message}
      isSpan={false}
      color={colors.all.black}
      style={{
        width: "100%",
        justifyContent: "center",
        alignItems: "center",
        wordWrap: "break-word",
        overflow: "hidden",
        backgroundColor: textColors.backgroundColor
      }}
    />
  );
});

export const MessageHiddenStatus = withLiteObserverAndTheme<{
  isDeleted: E_MESSAGE_DELETION_STATUS;
  deletedOn: string;
}>((props) => {
  const { isDeleted, deletedOn } = props;

  switch (isDeleted) {
    case E_MESSAGE_DELETION_STATUS.HIDDEN_FROM_ME:
    case E_MESSAGE_DELETION_STATUS.HIDDEN_FROM_EVERYONE: {
      const imageName =
        isDeleted === E_MESSAGE_DELETION_STATUS.HIDDEN_FROM_ME
          ? "hide-from-me"
          : "hide-from-everyone";
      return (
        <ET3Div
          width={0}
          height={0}
          alignItems={"center"}
          fDirection={"column"}
          style={{
            width: "100%",
            height: "100%"
          }}
          color={colors.all.transparent}
          justifyContent={"center"}
          withShadow={false}
          isExtendable={false}
          isScrollable={false}
          onClick={() => {}}
        >
          <Et3Image
            type="LOCAL"
            alt={imageName}
            imageName={imageName}
            size={28}
            onClick={() => {}}
            style={{}}
          />
          <Et3Text
            fontFamily={"LIGHT"}
            fontSize={10}
            isSpan={true}
            text={deletedOn}
            style={{}}
            color={colors.all.black}
          />
        </ET3Div>
      );
    }
    default:
      return (
        <Et3Text
          fontFamily={"MEDIUM"}
          fontSize={20}
          isSpan={false}
          text={i18n.get("NOT_APPLICABLE")}
          style={{
            width: "100%",
            justifyContent: "center",
            alignItems: "center"
          }}
          color={colors.all.black}
        />
      );
  }
});

export const EditProfileHistory = withLiteObserverAndTheme<{
  description: string;
}>((props) => {
  const { description, theme } = props;
  const { colors } = theme;

  const reducedDescription = reduce(() => description, "");

  return (
    <Et3Text
      fontFamily={"MEDIUM"}
      fontSize={20}
      text={`${reducedDescription}`}
      isSpan={false}
      color={colors.all.maastrichtBlue}
      style={{}}
    />
  );
});

export const OldExtraDataEvents = withLiteObserverAndTheme<{
  eventType: string;
  extraData: string;
}>((props) => {
  const { eventType, extraData, theme } = props;
  const { colors } = theme;

  const { hasBadWords, hasSocialMedia } =
    checkIfHasBadWordsAndSocialMedia(extraData);

  let textColors = {
    backgroundColor: "",
    textColor: ""
  };
  if (
    eventType === "APPROVE_DESCRIPTION" ||
    eventType === "REJECT_DESCRIPTION" ||
    eventType === "APPROVE_PEER_DESCRIPTION" ||
    eventType === "REJECT_PEER_DESCRIPTION"
  ) {
    textColors = hasBadWords
      ? {
          backgroundColor: colors.all.red,
          textColor: colors.all.white
        }
      : hasSocialMedia
        ? {
            backgroundColor: colors.all.orange,
            textColor: colors.all.white
          }
        : {
            backgroundColor: colors.all.transparent,
            textColor: colors.all.black
          };
  }

  return eventType === "UPDATE_PICTURE_APPROVE" ||
    eventType === "REJECT_PICTURE" ||
    eventType === "APPROVE_PICTURE" ||
    eventType === "UPDATE_PICTURE_REJECT" ? (
    <Et3Image
      type="ONLINE"
      alt={i18n.get("USER")}
      imageName={`${configuration.pictureUrl}${extraData}`}
      size={200}
      onClick={() => {}}
      style={{}}
    />
  ) : (
    <Et3Text
      fontFamily={"LIGHT"}
      fontSize={16}
      text={`${extraData}`}
      isSpan={false}
      color={textColors.textColor}
      style={{
        backgroundColor: textColors.backgroundColor,
        wordWrap: "break-word",
        width: "100%"
      }}
    />
  );
});

export const ExtraDataEvents = withLiteObserverAndTheme<{
  eventType: string;
  imageSource: string;
  description: string;
  reportID: number;
  investigationCaseID: number;
  temporaryBanUntil: string;
  temporaryBanNumberOfDays: number;
  extraData: string;
}>((props) => {
  const {
    eventType,
    imageSource,
    description,
    reportID,
    investigationCaseID,
    temporaryBanUntil,
    temporaryBanNumberOfDays,
    extraData,
    theme
  } = props;
  const { colors } = theme;

  const reducedDescription = reduce(() => description, "");
  const reducedReportID = reduce(() => reportID, -1);

  const { hasBadWords, hasSocialMedia } =
    checkIfHasBadWordsAndSocialMedia(reducedDescription);

  const textColors = DESCRIPTION_EVENTS.includes(eventType)
    ? hasBadWords
      ? { backgroundColor: colors.all.red, textColor: colors.all.white }
      : hasSocialMedia
        ? {
            backgroundColor: colors.all.orange,
            textColor: colors.all.white
          }
        : {
            backgroundColor: colors.all.transparent,
            textColor: colors.all.black
          }
    : {
        backgroundColor: colors.all.transparent,
        textColor: colors.all.black
      };

  if (PICTURE_EVENTS.includes(eventType)) {
    return (
      <Et3Image
        type="ONLINE"
        alt={i18n.get("USER")}
        imageName={`${configuration.pictureUrl}${imageSource}`}
        size={200}
        onClick={() => {}}
        style={{}}
      />
    );
  }

  const textParts = getExtraDataParts({
    eventType,
    extraData,
    description: reducedDescription,
    reportID: reducedReportID,
    investigationCaseID,
    temporaryBanUntil,
    temporaryBanNumberOfDays
  });

  return (
    <ET3Div
      isScrollable={false}
      isExtendable={true}
      fDirection="column"
      justifyContent="center"
      alignItems="center"
      withShadow={false}
      width={0}
      height={0}
      color={colors.all.transparent}
      style={{ width: "100%" }}
      onClick={() => {}}
    >
      {textParts.map((text, index) => (
        <Et3Text
          key={index}
          fontFamily="LIGHT"
          fontSize={16}
          text={text}
          isSpan={false}
          color={textColors.textColor}
          style={{
            backgroundColor: textColors.backgroundColor,
            wordWrap: "break-word",
            width: "100%"
          }}
        />
      ))}
    </ET3Div>
  );
});

export const LinkComponent = withLiteObserverAndTheme<{
  href: string;
  text: string;
  style: CSSProperties;
}>((props) => {
  const { href, text, style } = props;
  const isRecipientColored =
    getCoreHistoryStore().getPageName() === "USER_MESSAGES"
      ? reduce(
          () =>
            getUserMessagesStore().coloredReceipientMessage.get(parseInt(text)),
          false
        )
      : false;

  return (
    <Link
      to={href}
      target="_blank"
      style={{
        backgroundColor: colors.all.transparent,
        ...style
      }}
      aria-disabled={true}
    >
      <Et3Text
        fontFamily={"MEDIUM"}
        fontSize={15}
        text={`${text}`}
        isSpan={false}
        color={
          isRecipientColored
            ? colors.all.vibrantPinkishMagenta
            : colors.all.shadeOfBlueDark
        }
        style={{ textAlign: "center" }}
      />
    </Link>
  );
});

export const CsrAuditedEvents = withLiteObserverAndTheme<{
  textValue: string;
  issueType: string;
}>((props) => {
  const { textValue, issueType } = props;
  const pageNameFromCore = getCoreHistoryStore().pageName.get();

  const isLinkAvailable =
    isPositiveNumber(textValue) &&
    pageNameFromCore !== "AUDITOR_OTHER_CSR_PERFORMANCE";
  const dateMin = getMyCSRPerformanceStore().fromDate.get();
  const dateMax = getMyCSRPerformanceStore().toDate.get();

  return !isLinkAvailable ? (
    <Et3Text
      fontFamily={"LIGHT"}
      fontSize={15}
      text={`${textValue}`}
      isSpan={false}
      color={isLinkAvailable ? colors.all.bondiBlue : colors.all.maastrichtBlue}
      style={{ textAlign: "center" }}
    />
  ) : (
    <LinkComponent
      href={`/csr/my-csr-mistakes?eventName=total&&issueType=${issueType}&&dateMin=${dateMin.toLocaleDateString()}&&dateMax=${dateMax.toLocaleDateString()}`}
      text={`${textValue}`}
      style={{}}
    />
  );
});

export const HeaderWithTypeField = withLiteObserverAndTheme<{ value: string }>(
  (props) => {
    const { value } = props;
    const isSupervisePage =
      getCoreHistoryStore().getPageName() === "SUPERVISOR_SUPERVISE"
        ? true
        : false;

    const typeColor =
      value === "REJECT_PICTURE" ||
      value === "REJECT_DESCRIPTION" ||
      value === "REJECT_PEER_DESCRIPTION"
        ? colors.all.red
        : value === "APPROVE_PICTURE" ||
            value === "APPROVE_DESCRIPTION" ||
            value === "APPROVE_PEER_DESCRIPTION"
          ? colors.all.green
          : isSupervisePage
            ? "black"
            : "transparent";
    return (
      <Et3Text
        fontFamily={"MEDIUM"}
        fontSize={20}
        text={getClientReadableText(`${value}`)}
        isSpan={true}
        color={isSupervisePage ? typeColor : colors.all.maastrichtBlue}
        style={{
          width: "100%",
          textAlign: "center",
          wordWrap: "break-word",
          backgroundColor: !isSupervisePage ? typeColor : null
        }}
      />
    );
  }
);

export const SupervisorDashboardSalary = withLiteObserverAndTheme<{
  value: number;
}>((props) => {
  const { value, theme } = props;
  const { colors } = theme;
  const text = isPositiveNumber(value, true)
    ? `$${et3ReadableDecimalNumber(value, 2)}`
    : `-$${Math.abs(et3ReadableDecimalNumber(value, 2))}`;

  return (
    <Et3Text
      fontFamily={"LIGHT"}
      fontSize={20}
      text={text}
      isSpan={false}
      color={colors.all.black}
      style={{ textAlign: "center" }}
    />
  );
});

export const CSRReceiptConfiguration = withLiteObserverAndTheme<{
  type: "price" | "percentage";
  value: number;
}>((props) => {
  const { value, theme, type } = props;
  const { colors } = theme;
  const roundedValue = `${et3ReadableDecimalNumber(value, 2)}`;
  let stringValue = roundedValue;
  if (!stringValue.includes(".")) {
    stringValue = stringValue + ".00";
  }
  const text = type === "percentage" ? `${stringValue}%` : `$${stringValue}`;
  return (
    <Et3Text
      fontFamily={"LIGHT"}
      fontSize={15}
      text={text}
      isSpan={false}
      color={colors.all.black}
      style={{ textAlign: "center" }}
    />
  );
});

export const DevNewUsersIncreases = withLiteObserverAndTheme<{
  value: number;
}>((props) => {
  const { value, theme } = props;
  const { colors } = theme;
  return (
    <Et3Text
      fontFamily={"LIGHT"}
      fontSize={15}
      text={`${et3ReadableDecimalNumber(parseFloat(`${value}`), 2)}`}
      isSpan={false}
      color={colors.all.maastrichtBlue}
      style={{ textAlign: "center" }}
    />
  );
});

export const DevTurnOFFAlarm = withLiteObserverAndTheme<{
  AlarmId: number;
  reasonID: number;
}>((props) => {
  const { AlarmId, reasonID } = props;
  return (
    <Et3Button
      isEnabled={true}
      onClick={async () => {
        getDevelopmentAlarmsStore().setAlarmOff(AlarmId, reasonID);
      }}
      size="SMALL"
      text="ALARMS_OFF"
      type="REJECT"
    />
  );
});

export const DevFeatureAction = withLiteObserverAndTheme<{
  featureID: number;
  featureName: string;
  isActive: number;
  gender: string;
}>((props) => {
  const { featureID, featureName, isActive, gender } = props;
  return (
    <ET3Div
      isScrollable={false}
      isExtendable={false}
      withShadow={false}
      width={0}
      height={70}
      fDirection="row"
      alignItems="center"
      justifyContent="center"
      color={colors.all.transparent}
      style={{}}
      onClick={() => {}}
    >
      <Et3Button
        isEnabled={true}
        onClick={async () => {
          await getSupervisorKhattabatStore().updateKhattabatFeature(
            featureID,
            featureName,
            isActive,
            gender
          );
        }}
        size="MEDIUM"
        text={isActive ? "FEATURE_OFF" : "FEATURE_ON"}
        type={isActive ? "REJECT" : "APPROVE"}
      />
    </ET3Div>
  );
});

export const KhattabatAvailibilityCapacityChanger = withLiteObserverAndTheme<{
  updatedCapacityValue: string;
  adminId: number;
}>((props) => {
  const { updatedCapacityValue, adminId } = props;

  return (
    <ET3Div
      isScrollable={false}
      isExtendable={false}
      withShadow={false}
      width={300}
      height={200}
      fDirection="row"
      alignItems="center"
      justifyContent="center"
      color={colors.all.transparent}
      style={{}}
      onClick={() => {}}
    >
      <Et3Picker
        label={i18n.get("RC_CAPACITY")}
        options={KHATTABAT_CAPACITY_PICKER_OPTIONS()}
        onChoose={(value: TEt3PickerSingleValue) => {
          getSupervisorKhattabatStore().updateRCCapacityCountClient({
            adminId,
            updatedCapacityValue: parseInt(value.value)
          });
        }}
        value={{
          label: updatedCapacityValue,
          value: updatedCapacityValue
        }}
        style={{ marginRight: 10 }}
        isMultiple={false}
        onEnter={() => {}}
        onClick={() => {}}
        containerStyle={{}}
      />
    </ET3Div>
  );
});

export const FeatureRolloutPercentageChanger = withLiteObserverAndTheme<{
  featureId: number;
}>((props) => {
  const { featureId } = props;
  const isKhattabatFeatureRollOutPickersDataUpdateExists =
    getSupervisorKhattabatStore().isKhattabatFeatureRollOutPickersDataUpdateExists(
      featureId
    );

  const pickerData =
    getSupervisorKhattabatStore().khattabatFeaturesRollOutPickersData.get(
      featureId
    );

  return (
    <ET3Div
      isScrollable={false}
      isExtendable={true}
      withShadow={false}
      width={300}
      height={200}
      fDirection="column"
      alignItems="center"
      justifyContent="center"
      color={colors.all.transparent}
      style={{}}
      onClick={() => {}}
    >
      {!isKhattabatFeatureRollOutPickersDataUpdateExists ? null : (
        <Et3Button
          isEnabled={isKhattabatFeatureRollOutPickersDataUpdateExists}
          onClick={async () => {
            await getSupervisorKhattabatStore().updateFeatureRolloutPercentageOnDatabase(
              { featureId, newRO: pickerData.value }
            );
          }}
          size="MEDIUM"
          text={"UPDATE"}
          type={"APPROVE"}
        />
      )}
      <Et3Margin top={5} bottom={5} left={0} right={0} />
      <Et3Picker
        label={i18n.get("FEATURE_ROLLOUT_PERCENTAGE")}
        options={FEATURE_ROLLOUT_PICKER_OPTIONS()}
        onChoose={(value: TEt3PickerSingleValue) => {
          getSupervisorKhattabatStore().setKhattabatFeatureRollOutPickersData({
            featureId,
            value
          });
        }}
        value={pickerData}
        style={{ marginRight: 10 }}
        isMultiple={false}
        onEnter={() => {}}
        onClick={() => {}}
        containerStyle={{}}
      />
    </ET3Div>
  );
});

export const KhattabaAvailabilityCapacityUpdate = withLiteObserverAndTheme<{
  adminID: number;
  originalCapacityCount: number;
  updatedCapacityCount: number;
  totalActiveClients: number;
}>((props) => {
  const {
    adminID,
    originalCapacityCount,
    updatedCapacityCount,
    totalActiveClients
  } = props;
  const isUpdateExist =
    originalCapacityCount !== updatedCapacityCount &&
    updatedCapacityCount >= totalActiveClients;

  return (
    <Et3Button
      isEnabled={isUpdateExist}
      onClick={async () => {
        await getSupervisorKhattabatStore().updateKhattabaCapacityOnDatabase({
          adminID,
          updatedCapacityCount
        });
      }}
      size="MEDIUM"
      text={"UPDATE"}
      type={"APPROVE"}
    />
  );
});

export const QAIOSPayemntReciept = withLiteObserverAndTheme<{
  receipt: string;
}>((props) => {
  const { receipt } = props;
  return (
    <ET3Div
      isScrollable={true}
      isExtendable={false}
      fDirection="row"
      justifyContent="flex-start"
      alignItems="flex-start"
      withShadow={false}
      width={200}
      height={300}
      color={colors.all.transparent}
      style={{
        width: "100%",
        wordBreak: "break-word",
        overflowX: "hidden"
      }}
      onClick={() => {}}
    >
      <Et3Text
        fontFamily={"MEDIUM"}
        fontSize={15}
        text={receipt}
        isSpan={false}
        color={colors.all.bondiBlue}
        style={{}}
      />
    </ET3Div>
  );
});

export const QACopyReciept = withLiteObserverAndTheme<{ receipt: string }>(
  (props) => {
    const { receipt } = props;
    const reducedReceipt = reduce(() => receipt, "");
    const isCopied = reduce(
      () => getQAStore().isReceiptCopied.get(reducedReceipt),
      false
    );

    return (
      <Et3Button
        isEnabled={true}
        onClick={() => {
          return getQAStore().copyReceiptLink(reducedReceipt);
        }}
        size="SMALL"
        text={isCopied ? "COPIED" : "COPY"}
        type={isCopied ? "REJECT" : "GET"}
      />
    );
  }
);

export const OldSuperviseExtraData = withLiteObserverAndTheme<{
  type: string;
  extra_data: string;
  page_name: string;
}>((props) => {
  const { type, extra_data, page_name } = props;
  switch (page_name) {
    case "REPORTS":
      const report = reduce(() => JSON.parse(extra_data), {});
      const reportIdFromObject = reduce(() => report.reportId, 0);
      const reportId = isPositiveNumber(reportIdFromObject)
        ? reportIdFromObject
        : report;
      return (
        <Link
          to={`/reports?id=${reportId}`}
          target="_blank"
          style={{
            backgroundColor: colors.all.transparent
          }}
          aria-disabled={true}
        >
          <Et3Text
            fontFamily={"MEDIUM"}
            fontSize={15}
            text={reportId}
            isSpan={false}
            color={colors.all.white}
            style={{
              backgroundColor: colors.all.bondiBlue,
              padding: 5,
              borderRadius: 10
            }}
          />
        </Link>
      );
    case "INVESTIGATION_CASES":
      const reports: string[] = reduce(() => JSON.parse(extra_data), []);
      return (
        <ET3Div
          isScrollable={false}
          isExtendable={true}
          fDirection="column"
          justifyContent="center"
          alignItems="center"
          withShadow={false}
          width={70}
          height={0}
          color={colors.all.transparent}
          style={{ width: "100%" }}
          onClick={() => {}}
        >
          {reports.map((data) => (
            <Et3Text
              fontFamily={"MEDIUM"}
              fontSize={15}
              text={data}
              isSpan={false}
              color={colors.all.black}
              style={{}}
            />
          ))}
        </ET3Div>
      );
    default:
      return <OldExtraDataEvents eventType={type} extraData={extra_data} />;
  }
});

export const SuperviseExtraData = withLiteObserverAndTheme<{
  type: string;
  page_name: string;
  image_source: string;
  description: string;
  reportID: number;
  investigationCaseID: number;
  temporaryBanUntil: string;
  temporaryBanNumberOfDays: number;
  extraData: string;
}>((props) => {
  const {
    type,
    image_source,
    description,
    reportID,
    investigationCaseID,
    temporaryBanNumberOfDays,
    temporaryBanUntil,
    extraData,
    page_name
  } = props;
  switch (page_name) {
    case "REPORTS":
      const reducedReportID = reduce(() => reportID, -1);
      return (
        <Link
          to={
            !isPositiveNumber(reducedReportID)
              ? ``
              : `/reports?id=${reducedReportID}`
          }
          target="_blank"
          style={{
            backgroundColor: colors.all.transparent
          }}
          aria-disabled={true}
          onClick={(e) => {
            if (!isPositiveNumber(reducedReportID)) {
              e.preventDefault();
            }
          }}
        >
          <Et3Text
            fontFamily={"MEDIUM"}
            fontSize={15}
            text={`${reducedReportID}`}
            isSpan={false}
            color={colors.all.white}
            style={{
              backgroundColor: colors.all.bondiBlue,
              padding: 5,
              borderRadius: 10
            }}
          />
        </Link>
      );

    default:
      const reducedDescription = reduce(() => description, "");
      return (
        <ExtraDataEvents
          eventType={type}
          imageSource={image_source}
          description={reducedDescription}
          reportID={-1}
          temporaryBanNumberOfDays={temporaryBanNumberOfDays}
          temporaryBanUntil={temporaryBanUntil}
          investigationCaseID={investigationCaseID}
          extraData={extraData}
        />
      );
  }
});

export const DropDownOfPermission = withLiteObserverAndTheme<{
  hasPermissionCurrentState: number;
  moduleId: number;
}>((props) => {
  const { theme, hasPermissionCurrentState, moduleId } = props;
  const { colors } = theme;

  return (
    <ET3Div
      isScrollable={false}
      isExtendable={false}
      withShadow={false}
      width={300}
      height={250}
      fDirection="row"
      alignItems="center"
      justifyContent="center"
      color={colors.all.transparent}
      style={{}}
      onClick={() => {}}
    >
      <Et3Picker
        label={""}
        options={SUPERVISOR_PERMISSIONS_OPTIONS}
        value={SUPERVISOR_PERMISSIONS_OPTIONS[hasPermissionCurrentState]}
        onChoose={(option: TEt3PickerSingleValue) => {
          if (parseInt(option.value, 10) === hasPermissionCurrentState) {
            return;
          }
          getPermissionStore().changePermission({
            hasPermissionCurrentState,
            moduleId
          });
        }}
        style={{}}
        isMultiple={false}
        onEnter={() => {}}
        onClick={() => {}}
        containerStyle={{
          backgroundColor: hasPermissionCurrentState
            ? `${colors.all.green}`
            : ` ${colors.all.red}`
        }}
      />
    </ET3Div>
  );
});

export const SuperviseActions = withLiteObserverAndTheme<{
  type: "AUDIT_REASON" | "SUPERVISE_REASON";
  fromPage: "AUDITOR_AUDIT" | "SUPERVISOR_SUPERVISE";
  event_id: StringOrNumber;
  user_id_number: StringOrNumber;
  userUUID: string;
  event_type: StringOrNumber;
}>((props) => {
  const {
    type,
    event_id,
    user_id_number,
    userUUID,
    event_type,
    fromPage,
    theme
  } = props;
  const { colors } = theme;
  const tbwExtraData: TTBWExtraData = {
    userID: getUserAdvancedStore().currentUserId.get(),
    userUUID,
    reportedUUID: "",
    reportedID: -1,
    reportID: -1,
    secondPartyID: -1
  };
  const eventID: StringOrNumber = reduce(() => event_id, 0);
  const userIDNumber = isNumber(user_id_number)
    ? user_id_number
    : parseInt(user_id_number, 10);
  const eventIDNumber = isNumber(eventID) ? eventID : parseInt(eventID, 10);
  const eventType = isString(event_type) ? event_type : "";
  const buttonDisabled = isDefinedString(getTBWStore().TBWreasonType.get());
  //when we open the popup of major or minor issue so we will have a reason type and it will be not empty
  //string so we prevent the csr to click any action button while this popup is opened by disabling it
  return (
    <ET3Div
      isScrollable={false}
      isExtendable={false}
      withShadow={false}
      width={200}
      height={150}
      fDirection="column"
      alignItems="center"
      justifyContent="center"
      color={colors.all.transparent}
      style={{}}
      onClick={() => {}}
    >
      <Et3Button
        onClick={async () => {
          await getTBWStore().showActionTBWPopUp({
            type,
            headerMessage: i18n.getWithExtraData(
              "SELECT_REASONS_OF_ACTION",
              "Minor or Major"
            ),
            actionName: "",
            fromPage,
            extraData: tbwExtraData,
            eventId: eventID,
            issueAudit: "minor"
          });
        }}
        isEnabled={!buttonDisabled}
        type="WARN"
        size="MEDIUM"
        text="MINOR_ISSUE"
      />

      <Et3Margin top={10} bottom={0} left={0} right={0} />
      <Et3Button
        onClick={async () => {
          await getTBWStore().showActionTBWPopUp({
            type,
            headerMessage: i18n.getWithExtraData(
              "SELECT_REASONS_OF_ACTION",
              "Minor or Major"
            ),
            actionName: "",
            fromPage,
            extraData: tbwExtraData,
            eventId: eventID,
            issueAudit: "major"
          });
        }}
        isEnabled={!buttonDisabled}
        size="MEDIUM"
        type="REJECT"
        text="MAJOR_ISSUE"
      />

      <Et3Margin top={10} bottom={0} left={0} right={0} />
      <Et3Button
        onClick={async () => {
          if (type === "AUDIT_REASON") {
            getTBWStore().auditEventProof.set("no_issue");
            return await getAuditStore().takeAuditAction({
              actionType: "no_issue",
              userID: userIDNumber,
              userUUID,
              eventID: eventIDNumber,
              eventType,
              imageID: ""
            });
          } else {
            const eventIDNumber = isDefinedString(eventID)
              ? parseInt(eventID, 10)
              : eventID;
            getTBWStore().superviseEventProof.set("no_issue");
            return await getSuperviseStore().saveAuditedEventAsSupervised({
              eventID: eventIDNumber,
              issueType: "no_issue"
            });
          }
        }}
        isEnabled={!buttonDisabled}
        type="APPROVE"
        size="MEDIUM"
        text="NO_ISSUE"
      />
    </ET3Div>
  );
});

export const SupervisorEventUserID = withLiteObserverAndTheme<{
  supervisoreUserID: number;
  gender: string;
}>((props) => {
  const { supervisoreUserID, gender } = props;
  const blockColor =
    gender === "m" ? colors.all.bluishGreenish : colors.all.translucentPink;
  return (
    <LinkComponent
      href={`/users/advanced?id=${supervisoreUserID}`}
      text={`${supervisoreUserID}`}
      style={{
        width: "100%",
        textAlign: "center",
        backgroundColor: blockColor,
        color: colors.all.shadeOfBlueDark
      }}
    />
  );
});

export const SupervisorDeleteButton = withLiteObserverAndTheme<{
  text: string;
}>((props) => {
  const { text } = props;
  return (
    <Et3Button
      isEnabled={true}
      onClick={() => {
        const parsedValue = parseInt(`${text}`, 10);
        getFlaggedDesctiprionStore().deleteFlaggedDescriptions(parsedValue);
      }}
      size="SMALL"
      text="DELETE"
      type="REJECT"
    />
  );
});

export const SupervisorResetPasswordButton = withLiteObserverAndTheme<{
  adminID: number;
  fullName: string;
}>((props) => {
  const { adminID, fullName } = props;
  return (
    <Et3Button
      isEnabled={true}
      onClick={async () => {
        getResetPasswordStore().setSelectedAdmin(adminID, fullName);
        getCorePopUpStore().openConfirmationPopUps("RESET_PASSWORD_POPUP");
      }}
      size="MEDIUM"
      text="RESET_PASSWORD"
      type="APPROVE"
    />
  );
});

export const SupervisorIssuesCount = withLiteObserverAndTheme<{
  issuesCount: number;
  eventType: TReceiptCompensationTitles;
}>((props) => {
  const { issuesCount, eventType } = props;
  return (
    <ET3Div
      isScrollable={false}
      isExtendable={false}
      fDirection="row"
      justifyContent="center"
      alignItems="center"
      withShadow={false}
      width={100}
      height={50}
      color={""}
      style={{}}
      onClick={() => {}}
    >
      <Et3TextInput
        id={eventType}
        size="EXTRA_SMALL"
        withShadow={true}
        icon={null}
        type={"number"}
        label={""}
        placeHolder={""}
        value={issuesCount}
        onChoose={(value: number) => {
          getSupervisorReceiptStore().tableInputID.set(eventType);
          getSupervisorReceiptStore().setAdminIssuesCounts(eventType, value);
        }}
        onBlur={() => {}}
        style={{}}
        onEnter={() => {}}
      />
    </ET3Div>
  );
});

export const ReasonsArrayDisplay = withLiteObserverAndTheme<{
  reasons: string[];
}>((props) => {
  const { theme, reasons } = props;
  const { colors } = theme;

  return (
    <ET3Div
      isScrollable={false}
      isExtendable={true}
      withShadow={false}
      width={0}
      height={60}
      fDirection="column"
      alignItems="center"
      justifyContent="center"
      color={colors.all.transparent}
      style={{
        width: "100%"
      }}
      onClick={() => {}}
    >
      {isDefinedArray(reasons) ? (
        reasons.map((reason) => {
          return (
            <Et3Text
              fontFamily={"LIGHT"}
              fontSize={12}
              text={isDefinedString(reason) ? `${reason}` : "No Reason"}
              isSpan={false}
              color={colors.all.black}
              style={{
                width: "80%",
                textAlign: "center"
              }}
            />
          );
        })
      ) : (
        <Et3Text
          fontFamily={"MEDIUM"}
          fontSize={12}
          text={"No Reason"}
          isSpan={false}
          color={colors.all.black}
          style={{ width: "100%", textAlign: "center" }}
        />
      )}
    </ET3Div>
  );
});

export const AuditedExtraData = withLiteObserverAndTheme<{
  auditedDataType: string;
  auditedPageName: string;
  auditedExtraData: string;
  auditedImageSource: string;
  auditedDescription: string;
  auditedReportID: number;
  auditedInvestigationcCaseID: number;
  auditedTemporaryBanUntil: string;
  auditedTemporaryBanNumberOfDays: number;
}>((props) => {
  const {
    auditedDataType,
    auditedPageName,
    auditedImageSource,
    auditedDescription,
    auditedReportID,
    auditedInvestigationcCaseID,
    auditedTemporaryBanNumberOfDays,
    auditedTemporaryBanUntil,
    auditedExtraData
  } = props;
  if (auditedPageName === "REPORTS") {
    const reducedReportID = reduce(() => auditedReportID, -1);
    return (
      <Link
        to={`/reports?id=${reducedReportID}`}
        target="_blank"
        style={{
          backgroundColor: colors.all.transparent
        }}
        aria-disabled={true}
        onClick={(e) => {
          if (!isPositiveNumber(reducedReportID)) {
            e.preventDefault();
          }
        }}
      >
        <Et3Text
          fontFamily={"MEDIUM"}
          fontSize={15}
          text={`${reducedReportID}`}
          isSpan={false}
          color={colors.all.white}
          style={{
            backgroundColor: colors.all.bondiBlue,
            padding: 5,
            borderRadius: 10
          }}
        />
      </Link>
    );
  }
  return (
    <ExtraDataEvents
      eventType={auditedDataType}
      imageSource={auditedImageSource}
      description={auditedDescription}
      reportID={-1}
      temporaryBanUntil={auditedTemporaryBanUntil}
      temporaryBanNumberOfDays={auditedTemporaryBanNumberOfDays}
      investigationCaseID={auditedInvestigationcCaseID}
      extraData={auditedExtraData}
    />
  );
});

export const WebPaymentStatusColumn = withLiteObserverAndTheme<{
  paymentColumnStatus: EHyperpayPaymentStatus;
  referenceID: string;
  userIDToUseInVIP: number;
  isActiveSubscription: boolean;
}>((props) => {
  const {
    theme,
    referenceID,
    userIDToUseInVIP,
    paymentColumnStatus,
    isActiveSubscription
  } = props;
  const { colors } = theme;
  const isWebPaymentAlreayRefunded =
    getWebPayments().isWebPaymentAlreayRefunded(referenceID);
  const paymentColumnStatusCancelled =
    paymentColumnStatus === EHyperpayPaymentStatus.SUBSCRIPTION_CANCELLED;
  const paymentColumnStatusExpired =
    paymentColumnStatus === EHyperpayPaymentStatus.SUBSCRIPTION_EXPIRED;
  const cancelDisabled =
    paymentColumnStatusCancelled ||
    paymentColumnStatusExpired ||
    !isActiveSubscription;

  return (
    <ET3Div
      isScrollable={false}
      isExtendable={false}
      fDirection="row"
      justifyContent="center"
      alignItems="center"
      withShadow={false}
      width={232}
      height={55}
      color={colors.all.transparent}
      style={{}}
      onClick={() => {}}
    >
      {paymentColumnStatus === EHyperpayPaymentStatus.SUBSCRIPTION_REFUNDED ? (
        <Et3Text
          fontFamily={"BOLD"}
          fontSize={20}
          text={"REFUNDED"}
          isSpan={false}
          color={colors.all.bondiBlue}
          style={{}}
        />
      ) : (
        <React.Fragment>
          <Et3Button
            isEnabled={!cancelDisabled}
            onClick={() => {
              getWebPayments().setWebPaymentCancelObject(
                cancelDisabled,
                userIDToUseInVIP,
                referenceID,
                paymentColumnStatus
              );
            }}
            size="SMALL"
            text={paymentColumnStatusCancelled ? "CANCELLED" : "CANCEL"}
            type="GET"
          />
          <Et3Margin top={0} bottom={0} left={10} right={0} />
          <Et3Button
            isEnabled={true}
            onClick={() => {
              getWebPayments().setWebPaymentRefundObject(
                isWebPaymentAlreayRefunded,
                userIDToUseInVIP,
                referenceID
              );
            }}
            size="SMALL"
            text="REFUND"
            type="APPROVE"
          />
        </React.Fragment>
      )}
    </ET3Div>
  );
});

export const InvestigationButton = ({
  user_id,
  action_place,
  action_id,
  button_type
}: {
  user_id: number;
  action_place: string;
  action_id: number;
  button_type: "link" | "messages" | "profile";
}) => {
  let hrefVal = ``;
  let buttonText: Ti18nKeys = "EMPTY_STRING";
  let eventName = ``;
  let fromPage: TCorePage = `INVESTIGATION_CASES`;
  if (button_type === "link") {
    buttonText =
      action_place === "USER_ADVANCED"
        ? "GO_TO_USER_ADVANCED"
        : action_place === "CONVERSATIONS"
          ? "CONVERSATIONS"
          : action_place === "REPORTS"
            ? "REPORTS"
            : "EMPTY_STRING";
    eventName =
      action_place === "USER_ADVANCED"
        ? "GO_TO_USER"
        : action_place === "CONVERSATIONS"
          ? "GO_TO_CONVERSATIONS"
          : "GO_TO_REPORT";
    if (isPositiveNumber(user_id)) {
      if (action_place === "USER_ADVANCED") {
        hrefVal = `/users/advanced?id=${user_id}`;
      }
      if (action_place === "CONVERSATIONS") {
        hrefVal = `/users/conversations?senderID=${user_id}&&recipientID=${action_id}`;
      }
      if (action_place === "REPORTS") {
        hrefVal = `/reports?id=${action_id}`;
      }
    }
  } else if (button_type === "messages") {
    buttonText = "GO_TO_MESSAGES";
    hrefVal = `/users/messages?id=${user_id}`;
    eventName = `GO_TO_MESSAGES`;
  } else {
    buttonText = "GO_TO_USER_ADVANCED";
    hrefVal = `/users/advanced?id=${user_id}`;
    eventName = `GO_TO_USER`;
  }
  const eventTypeButtonHidden = buttonText === "EMPTY_STRING";
  return eventTypeButtonHidden ? null : (
    <Et3ATag href={hrefVal} target="_blank" style={{ textDecoration: "auto" }}>
      <Et3Button
        size="MEDIUM"
        isEnabled={true}
        onClick={async () => {
          await getCorePersonalStore().insertAdminEvent({
            eventName,
            fromPage,
            userID: parseInt(`${user_id}`, 10),
            extraData: {}
          });
        }}
        type="GET"
        text={buttonText}
      />
    </Et3ATag>
  );
};

export const ResolveInvestigationCases = withLiteObserverAndTheme<{
  invResolveInvestigationId: number;
  invResolveUserUUID: string;
  invResolveReasons: string[];
}>((props) => {
  const { invResolveInvestigationId, invResolveUserUUID, invResolveReasons } =
    props;

  const reasons = isDefinedArray(invResolveReasons) ? invResolveReasons : [""];

  return (
    <Et3Button
      size="SMALL"
      onClick={async () => {
        await getInvestigationCasesStore().updateInvestigationCase({
          investigationCaseID: parseInt(`${invResolveInvestigationId}`, 10),
          eventName: "RESOLVE_INVESTIGATION_CASE",
          fromPage: "INVESTIGATION_CASES",
          userUUID: invResolveUserUUID,
          extraData: reasons
        });
      }}
      isEnabled={true}
      text={"RESOLVE"}
      type="APPROVE"
    />
  );
});

export const BannedUserDescText = withLiteObserverAndTheme<{
  text: string;
  isFlagged: boolean;
}>((props) => {
  const { text, isFlagged } = props;

  return (
    <Et3Text
      fontFamily={"MEDIUM"}
      fontSize={16}
      text={text}
      isSpan={false}
      color={isFlagged ? colors.all.red : colors.all.black}
      style={{
        justifyContent: "center",
        alignItems: "center",
        wordWrap: "break-word",
        overflow: "hidden",
        width: "100%"
      }}
    />
  );
});

export const MessageIDText = withLiteObserverAndTheme<{ messageID: string }>(
  (props) => {
    const { messageID } = props;
    const searchedMessageID =
      messageID === `${getUserMessageIdStore().messageIdInput.get()}`;

    return (
      <Et3Text
        fontFamily={"MEDIUM"}
        fontSize={16}
        text={`${messageID}`}
        isSpan={false}
        color={colors.all.black}
        style={{
          width: "100%",
          backgroundColor: searchedMessageID
            ? colors.all.yellow
            : colors.all.transparent
        }}
      />
    );
  }
);

export const DropDownMembersOfDepatment = withLiteObserverAndTheme<{
  team: TOnCallTeams;
}>((props) => {
  const { theme, team } = props;
  const { colors } = theme;
  const departmentOnCallMembers =
    getOnCallTeamStore().getDepartmentOnCallMembers(team);

  return (
    <ET3Div
      isScrollable={false}
      isExtendable={false}
      withShadow={false}
      width={300}
      height={380}
      fDirection="row"
      alignItems="center"
      justifyContent="center"
      color={colors.all.transparent}
      style={{}}
      onClick={() => {}}
    >
      {team !== E_ADMIN_ROLE.CEO && team !== E_ADMIN_ROLE.CTO ? (
        <Et3Picker
          label={""}
          options={departmentOnCallMembers}
          value={getOnCallTeamStore().getSelectedMember(team)}
          onChoose={(value: TEt3PickerSingleValue) => {
            getOnCallTeamStore().setOnCallmember(value, team);
          }}
          style={{}}
          isMultiple={false}
          onEnter={() => {}}
          onClick={() => {}}
          containerStyle={{}}
        />
      ) : null}
    </ET3Div>
  );
});

export const HeaderWithSubtitle = withLiteObserverAndTheme<{
  title: string;
  subtitle: string;
}>((props) => {
  const { title, subtitle } = props;

  return (
    <ET3Div
      width={0}
      height={0}
      alignItems={"center"}
      fDirection={"column"}
      style={{
        lineHeight: 1.2,
        width: "100%",
        height: "100%",
        whiteSpace: "normal",
        wordWrap: "break-word"
      }}
      color={""}
      justifyContent={"center"}
      withShadow={false}
      isExtendable={false}
      isScrollable={false}
      onClick={() => {}}
    >
      <Et3Text
        fontFamily={"LIGHT"}
        fontSize={14}
        isSpan={true}
        text={title}
        style={{}}
        color={""}
      />
      <Et3Text
        fontFamily={"LIGHT"}
        fontSize={10}
        isSpan={true}
        text={subtitle}
        style={{
          wordWrap: "break-word"
        }}
        color={""}
      />
    </ET3Div>
  );
});
